import {
  getLeoUuid,
  LeoUUID,
  getString,
  getLeoTimestamp,
  LeoTimestamp,
  getOptionalLeoUuid,
} from "@surya-digital/leo-ts-types";

export interface GetArchivedResearcherProjectsPaginationResponseDTO {
  projectId: string;
  projectName: string;
  creator: string;
  surveys: string;
  createdOn: string;
  lastModified: string;
  boUserId?: string | null;
}

export class GetArchivedResearcherProjectsPaginationResponse {
  readonly isGetArchivedResearcherProjectsPaginationResponseGetArchivedResearcherProjectsPaginationResponse: boolean = true;

  readonly projectId: LeoUUID;
  readonly projectName: string;
  readonly creator: string;
  readonly surveys: string;
  readonly createdOn: LeoTimestamp;
  readonly lastModified: LeoTimestamp;
  readonly boUserId: LeoUUID | null;


  constructor(
  projectId: LeoUUID, 
  projectName: string, 
  creator: string, 
  surveys: string, 
  createdOn: LeoTimestamp, 
  lastModified: LeoTimestamp, 
  boUserId: LeoUUID | null = null
  ) {
    this.projectId = projectId;
    GetArchivedResearcherProjectsPaginationResponse.validateProjectName(projectName);
    this.projectName = projectName;
    GetArchivedResearcherProjectsPaginationResponse.validateCreator(creator);
    this.creator = creator;
    GetArchivedResearcherProjectsPaginationResponse.validateSurveys(surveys);
    this.surveys = surveys;
    this.createdOn = createdOn;
    this.lastModified = lastModified;
    this.boUserId = boUserId;
  }

  static fromDTO(dto: GetArchivedResearcherProjectsPaginationResponseDTO): GetArchivedResearcherProjectsPaginationResponse {
    const projectId = getLeoUuid(dto, "projectId", InvalidGetArchivedResearcherProjectsPaginationResponseProjectIdError);
    const projectName = getString(dto, "projectName", InvalidGetArchivedResearcherProjectsPaginationResponseProjectNameError);
    const creator = getString(dto, "creator", InvalidGetArchivedResearcherProjectsPaginationResponseCreatorError);
    const surveys = getString(dto, "surveys", InvalidGetArchivedResearcherProjectsPaginationResponseSurveysError);
    const createdOn = getLeoTimestamp(dto, "createdOn", InvalidGetArchivedResearcherProjectsPaginationResponseCreatedOnError);
    const lastModified = getLeoTimestamp(dto, "lastModified", InvalidGetArchivedResearcherProjectsPaginationResponseLastModifiedError);
    const boUserId = getOptionalLeoUuid(dto, "boUserId", InvalidGetArchivedResearcherProjectsPaginationResponseBoUserIdError);
    return new GetArchivedResearcherProjectsPaginationResponse(
      projectId,
      projectName,
      creator,
      surveys,
      createdOn,
      lastModified,
      boUserId
    );
  }

  toDTO(): GetArchivedResearcherProjectsPaginationResponseDTO {
    const dto: GetArchivedResearcherProjectsPaginationResponseDTO = {
        projectId: this.projectId.toDTO(),
        projectName: this.projectName,
        creator: this.creator,
        surveys: this.surveys,
        createdOn: this.createdOn.toDTO(),
        lastModified: this.lastModified.toDTO(),
    };
    if (this.boUserId !== undefined && this.boUserId !== null){
      dto.boUserId = this.boUserId.toDTO();
    }
    return dto;
  }
  private static validateProjectName = (projectName: string): void => {
    if(projectName.trim().length === 0) {
      throw new InvalidGetArchivedResearcherProjectsPaginationResponseProjectNameNonEmptyError(
        `Attribute projectName cannot be an empty string.`
      );
    }
  }
  private static validateCreator = (creator: string): void => {
    if(creator.trim().length === 0) {
      throw new InvalidGetArchivedResearcherProjectsPaginationResponseCreatorNonEmptyError(
        `Attribute creator cannot be an empty string.`
      );
    }
  }
  private static validateSurveys = (surveys: string): void => {
    if(surveys.trim().length === 0) {
      throw new InvalidGetArchivedResearcherProjectsPaginationResponseSurveysNonEmptyError(
        `Attribute surveys cannot be an empty string.`
      );
    }
  }
  
}

GetArchivedResearcherProjectsPaginationResponse.prototype.toString = function toString(): string {
  return `GetArchivedResearcherProjectsPaginationResponse(projectId='${this.projectId}',projectName='${this.projectName}',creator='${this.creator}',surveys='${this.surveys}',createdOn='${this.createdOn}',lastModified='${this.lastModified}',boUserId='${this.boUserId}')`;
};

export class InvalidGetArchivedResearcherProjectsPaginationResponseError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseError";
  }
}
export class InvalidGetArchivedResearcherProjectsPaginationResponseProjectIdError extends InvalidGetArchivedResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseProjectIdError";
  }
}

export class InvalidGetArchivedResearcherProjectsPaginationResponseProjectNameError extends InvalidGetArchivedResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseProjectNameError";
  }
}

export class InvalidGetArchivedResearcherProjectsPaginationResponseProjectNameNonEmptyError extends InvalidGetArchivedResearcherProjectsPaginationResponseProjectNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseProjectNameNonEmptyError";
  }
}

export class InvalidGetArchivedResearcherProjectsPaginationResponseCreatorError extends InvalidGetArchivedResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseCreatorError";
  }
}

export class InvalidGetArchivedResearcherProjectsPaginationResponseCreatorNonEmptyError extends InvalidGetArchivedResearcherProjectsPaginationResponseCreatorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseCreatorNonEmptyError";
  }
}

export class InvalidGetArchivedResearcherProjectsPaginationResponseSurveysError extends InvalidGetArchivedResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseSurveysError";
  }
}

export class InvalidGetArchivedResearcherProjectsPaginationResponseSurveysNonEmptyError extends InvalidGetArchivedResearcherProjectsPaginationResponseSurveysError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseSurveysNonEmptyError";
  }
}

export class InvalidGetArchivedResearcherProjectsPaginationResponseCreatedOnError extends InvalidGetArchivedResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseCreatedOnError";
  }
}

export class InvalidGetArchivedResearcherProjectsPaginationResponseLastModifiedError extends InvalidGetArchivedResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseLastModifiedError";
  }
}

export class InvalidGetArchivedResearcherProjectsPaginationResponseBoUserIdError extends InvalidGetArchivedResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsPaginationResponseBoUserIdError";
  }
}
